// @ts-nocheck
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Get_PerContractType } from '../../store/Lookup/lookupSlice';
import { useTranslation } from 'react-i18next';

const useLookupPerContractType = () => {
  const dispatch = useDispatch();
  const { i18n } = useTranslation();

  useEffect(() => {
    dispatch(Get_PerContractType());
  }, []);

  // @ts-ignore
  const { PerContractType, loading, error } = useSelector(state => state.Lookup);

  const OptionsPerContractType =
    PerContractType &&
    PerContractType?.map((item, idx) =>
      item.list?.map(list => ({
        value: list.lookupCode,
        label: i18n.language === 'en' ? list.meaning : list.meaning2
      }))
    ).flat();

  return { PerContractType, OptionsPerContractType, loading, error };
};

export default useLookupPerContractType;
